export default __webpack_public_path__ + "static/media/katiemccabe-desk.fb6385f4.mp4";